import script from "./MainMission.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMission.vue?vue&type=script&setup=true&lang=js"

import "./MainMission.vue?vue&type=style&index=0&id=6c36cf9b&lang=scss"

const __exports__ = script;

export default __exports__